import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AdminApiService } from 'src/@ccmc/services/admin-api.service';
import { AmplifyService } from 'src/@ccmc/services/amplify.service';
import { AssetService } from 'src/@ccmc/services/asset.service';
import { CcmcApiService } from 'src/@ccmc/services/ccmc-api.service';
import { SnackbarService } from 'src/@ccmc/services/snackbar.service';
import { CCMCSearchBorrowerDialogComponent } from '../search-borrower-dialog/search-borrower-dialog.component';
import { UpdateSpectrumCredentialsComponent } from '../update-spectrum-credentials/update-spectrum-credentials.component';

@Component({
  selector: 'app-select-spectrum-credentials',
  templateUrl: './select-spectrum-credentials.component.html',
  styleUrls: ['./select-spectrum-credentials.component.scss']
})
export class SelectSpectrumCredentialsComponent implements OnInit {
  spectrumUserCredentialItem: any;
  showPassword = false;
  localSpectrumUserCredentialItem: any;
  editedFlag = false;
  isNXTsoftOperations = false;
  isNXTsoftDev = false;
  isNXTsoftSales = false;
  isAdmin = false;
  isSuperAdmin = false;
  fiservUserTable: any[] = [];
  finalSpectrumTable: any[] = [];
  selectedRow: any;
  assetID: any;
  fiservTableKeys: any;
  constructor(
    private amplifyService: AmplifyService,
    private ccmcApiService: CcmcApiService,
    private snackBarService: SnackbarService,
    private dialogRef: MatDialogRef<SelectSpectrumCredentialsComponent>,
    private adminApiService: AdminApiService,
    private dialog: MatDialog,
    private assetService: AssetService
  ) {}

  ngOnInit(): void {
    this.localSpectrumUserCredentialItem = {
      cognitoID: this.amplifyService.getCognitoId(),
      tellerID: '',
      assetID: this.assetService.getSelectedAssetId(),
      username: this.amplifyService.username
    };
    this.selectedRow = {
      tellerID: '',
      cognitoID: '',
      assetID: this.assetService.getSelectedAssetId(),
      username: ''
    };
    this.getSpectrumCredentialsTable();
    this.isNXTsoftOperations = this.amplifyService.isNXTsoftOperations;
    this.isNXTsoftSales = this.amplifyService.isNXTsoftSales;
    this.isNXTsoftDev = this.amplifyService.isNXTsoftDev;
    this.isAdmin = this.amplifyService.isAdmin;
    this.isSuperAdmin = this.amplifyService.isSuperAdmin;
  }

  getSpectrumCredentialsTable() {
    this.adminApiService
      .getDynamoDB('fiserv_spectrum_users')
      .subscribe(result => {
        if (result) {
          const parsedResult = JSON.parse(JSON.stringify(result));
          this.fiservUserTable = parsedResult;
          for (let fiservUser of this.fiservUserTable) {
            if (fiservUser.assetID != undefined) {
              // Skips dialog selection if your credentials exist in list
              if (fiservUser.cognitoID === this.amplifyService.getCognitoId()) {
                this.selectedRow = fiservUser;
                this.editedFlag = true;
                this.continue();
              }
              if (
                fiservUser.assetID.includes(
                  this.assetService.getSelectedAssetId()
                )
              ) {
                this.finalSpectrumTable.push(fiservUser);
              }
            }
          }
        }
      });
  }

  continue() {
    this.selectedRow.cognitoID = this.amplifyService.getCognitoId();
    if (this.editedFlag) {
      this.ccmcApiService
        .createDynamoDB('test', 'fiserv_spectrum_users', this.selectedRow)
        .subscribe(result => {
          if (result) {
            this.dialogRef.close(true);
          }
        });
    }
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  checkPremCreds() {
    this.editedFlag = true;
  }

  isEquivalent(a: any, b: any) {
    // Create arrays of property names
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length !== bProps.length) {
      return false;
    }

    for (let i = 0; i < aProps.length; i++) {
      const propName = aProps[i];
      // If values of same property are not equal,
      // objects are not equivalent
      if (a[propName] !== b[propName]) {
        return false;
      }
    }
    return true;
  }

  openSpectrumCredentialsDialog() {
    const updateSpectrumCredentialsDialogRef = this.dialog.open(
      UpdateSpectrumCredentialsComponent,
      {
        panelClass: 'suffix-search__panel-dialog'
      }
    );
    updateSpectrumCredentialsDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dialog.closeAll();
        this.openSearchBorrowerDialog();
      }
    });
  }

  openSearchBorrowerDialog() {
    const searchBorrowerDialogRef = this.dialog.open(
      CCMCSearchBorrowerDialogComponent,
      {
        data: {},
        panelClass: 'search__panel-dialog'
      }
    );
  }
}
